var _rect, _path, _g, _defs;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgEmailFollowUpIcon = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 28,
    viewBox: "0 0 26 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 28,
    rx: 7,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3576_36954)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3576_36954",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 2,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 2.5H1.5V25.5H24.5V2.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3576_36954)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9999 5.81995C17.5176 5.81995 21.1799 9.48223 21.1799 13.9999C21.1799 18.5177 17.5176 22.18 12.9999 22.18C8.48225 22.18 4.81989 18.5177 4.81989 13.9999C4.81989 9.48223 8.48225 5.81995 12.9999 5.81995Z",
    fill: "#99C9FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.716 7.3158C18.6582 8.64869 19.212 10.2757 19.212 12.032C19.212 16.5498 15.5496 20.212 11.0319 20.212C9.27558 20.212 7.64863 19.6582 6.31573 18.716C7.79699 20.8116 10.2386 22.18 12.9999 22.18C17.5176 22.18 21.18 18.5176 21.18 13.9999C21.18 11.2386 19.8116 8.79705 17.716 7.3158Z",
    fill: "#0077F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1192 12.9602H15.0398V9.88086H11.9604V12.9602H8.88116V16.0396H11.9604V19.1189H15.0398V16.0396H18.1192V12.9602Z",
    fill: "#E6F7FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0398 9.5H11.9604C11.75 9.5 11.5794 9.67054 11.5794 9.88105V12.5793H8.88105C8.67062 12.5793 8.5 12.7498 8.5 12.9603V16.0397C8.5 16.2501 8.67062 16.4207 8.88105 16.4207H11.5794V19.1189C11.5794 19.3295 11.75 19.5 11.9604 19.5H15.0398C15.2503 19.5 15.4208 19.3295 15.4208 19.1189V16.4207H18.1191C18.3296 16.4207 18.5002 16.2501 18.5002 16.0397V12.9603C18.5002 12.7498 18.3296 12.5793 18.1191 12.5793H15.4208V9.88105C15.4208 9.67054 15.2502 9.5 15.0398 9.5ZM17.7381 13.3414V15.6585H15.0398C14.8292 15.6585 14.6587 15.8291 14.6587 16.0397V18.7379H12.3415V16.0397C12.3415 15.8291 12.1709 15.6585 11.9604 15.6585H9.2621V13.3414H11.9604C12.1709 13.3414 12.3415 13.1708 12.3415 12.9603V10.262H14.6587V12.9603C14.6587 13.1708 14.8292 13.3414 15.0398 13.3414H17.7381Z",
    fill: "#E6F7FE"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3576_36954"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white",
    transform: "translate(1.5 2.5)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEmailFollowUpIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/EmailFollowUpIcon.afd48850.svg";
export { ForwardRef as ReactComponent };